import React, { ReactElement } from "react";
import { ResponseRecord } from "reducers/responses/reducer";
import classNames from "classnames";
import Button from "components/Common/Button";
import adaEmbed from "services/ada-embed";
import { getChatURL } from "source/services/test-bot";

interface AdaEmbedProps {
  buttonProps?: Record<string, unknown>;
  customClassName?: string;
  triggerAnswer?: ResponseRecord;
}

class EmbedButton extends React.Component<AdaEmbedProps> {
  toggleBotBound = this.toggleBot.bind(this);

  postResponseIdMessage(): void {
    const { triggerAnswer } = this.props;
    const adaIframe = document.getElementById("ada-chat-frame") as HTMLIFrameElement;
    const targetOrigin = getChatURL();

    if (adaIframe) {
      adaIframe.contentWindow.postMessage({
        ada: {
          triggerAnswer: {
            response_id: triggerAnswer.get("id"),
            response_name: triggerAnswer.get("handle")
          }
        }
      }, targetOrigin);
    }
  }

  async toggleBot(): Promise<void> {
    const { triggerAnswer } = this.props;

    const { hasActiveChatter } = await adaEmbed.getInfo();

    if (triggerAnswer) {
      if (hasActiveChatter) {
        await adaEmbed.toggle();
        await adaEmbed.chatterReady;
        this.postResponseIdMessage();
      } else {
        await adaEmbed.reset({ greeting: triggerAnswer.get("id") });
        await adaEmbed.toggle();
      }
    } else {
      await adaEmbed.toggle();
    }
  }

  render(): ReactElement {
    const { customClassName, buttonProps } = this.props;

    return (
      <Button
        customClassName={classNames(customClassName)}
        onClick={this.toggleBotBound}
        {...buttonProps}
      />
    );
  }
}

export default EmbedButton;
